﻿import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { CONFIG } from '../../core/config';
import { AssignComplaint } from '../../core/models/administration/complaint-configuration/assign-complaint';
import { ComplaintComment } from '../../core/models/administration/complaint-configuration/complaint-comment';
import { ComplaintDetail } from '../../core/models/administration/complaint-configuration/complaint-detail';
import { ConfigurationParameter } from '../../core/models/administration/complaint-configuration/parameter-configuration';
import { SearchComplaints } from '../../core/models/administration/complaint-configuration/search-complaint-list';
import { ComplaintStatus } from '../../core/models/administration/complaint-configuration/update-complaint-status';
import { DropdownItem } from '../../core/models/dropdown-item';
import { ExceptionService } from '../../core/services/exception.service';
import { SpinnerService } from '../../core/spinner/spinner.service';
import { SortCommentsModel } from '../../core/models/administration/complaint-configuration/sort-comments';
@Injectable({
    providedIn: 'root'
})
export class ComplaintConfigurationService {

    constructor(private _http: HttpClient,
        private _exceptionService: ExceptionService,
        private _spinnerService: SpinnerService) { }

    searchComplaints(data: SearchComplaints): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.admin.complaintConfiguration.searchComplaints, data)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    getComplaintByID(id: number, langID: number): Observable<ComplaintDetail> {
        this._spinnerService.show();
        return this._http.get<ComplaintDetail>(CONFIG.baseUrls.admin.complaintConfiguration.getComplaintByID + id + "/" + langID)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    getComplaintCommentsByComplaintId(sortComments: SortCommentsModel): Observable<ComplaintComment[]> {
        this._spinnerService.show();
        return this._http.post<ComplaintComment[]>(CONFIG.baseUrls.admin.complaintConfiguration.getComplaintCommentsByComplaintId, sortComments)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }
    UpdateComplaintLocation(complaintDetails: any): Observable<number> {
        this._spinnerService.show();
        return this._http.post<number>(CONFIG.baseUrls.admin.complaintConfiguration.updateComplaintLocation, complaintDetails)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    uploadComplaintCommentFiles(formData): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.admin.complaintConfiguration.uploadCommentFiles, formData)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    addNewComplaintComment(newComment: ComplaintComment): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.admin.complaintConfiguration.addNewComplaintComment, newComment)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    uploadComplaintAnswerFiles(formData): Observable<any> {

        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.admin.complaintConfiguration.uploadAnswerFiles, formData)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    addComplaintAnswer(answer: ComplaintDetail): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.admin.complaintConfiguration.addComplaintAnswer, answer)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    getFilesByComplaintCommentId(complaintCommentId: number): Observable<any> {
        this._spinnerService.show();
        return this._http.get<any>(CONFIG.baseUrls.admin.complaintConfiguration.getFilesByComplaintCommentId + complaintCommentId)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    assignComplaintAndMakeItVisible(assignComplaint: AssignComplaint): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.admin.complaintConfiguration.assignComplaintAndMakeItVisible, assignComplaint)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    changeComplaintStatus(id: number, statusId: number): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.admin.complaintConfiguration.changeComplaintStatus + id + "/" + statusId, {})
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    setComplaintCommentActive(id: number, active: boolean): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.admin.complaintConfiguration.SetComplaintCommentActive, { Id: id, Active: active })
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    setComplaintCommentInappropriate(id: number, inappropriate: boolean): Observable<any> {
        this._spinnerService.show();
        return this._http.post<any>(CONFIG.baseUrls.admin.complaintConfiguration.SetComplaintCommentInappropriate, { Id: id, Inappropriate: inappropriate })
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    downloadFile(id: number, langID: number): Observable<Blob> {
        this._spinnerService.show();
        return this._http.post<Blob>(CONFIG.baseUrls.admin.complaintConfiguration.downloadFile, { ID: id, LangID: langID }, { responseType: 'blob' as 'json' })
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    downloadAnswerFile(id: number, langID: number): Observable<Blob> {
        this._spinnerService.show();
        return this._http.post<Blob>(CONFIG.baseUrls.admin.complaintConfiguration.downloadAnswerFile, { ID: id, LangID: langID }, { responseType: 'blob' as 'json' })
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    deleteAnswerFile(id: number): Observable<boolean> {
        this._spinnerService.show();
        return this._http.delete<boolean>(CONFIG.baseUrls.admin.complaintConfiguration.deleteAnswerFile + id)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    getImagesByComplaintID(complaintID: number): Observable<string[]> {
        this._spinnerService.show();
        return this._http.get<string[]>(CONFIG.baseUrls.admin.complaintConfiguration.getImagesByComplaintID + complaintID)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    updateComplaintStatus(data: ComplaintStatus): Observable<number> {
        this._spinnerService.show();
        return this._http.post<number>(CONFIG.baseUrls.admin.complaintConfiguration.updateComplaintStatus, data)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    getOrgUnitsDropdownForComplaintConfiguration(id: number,languageId: number): Observable<DropdownItem[]> {
        this._spinnerService.show();
        return this._http.get<DropdownItem[]>(CONFIG.baseUrls.complaint.getOrgUnitsDropdownForComplaintConfiguration + id + "/" + languageId)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

    deleteComplaintByID(id: number): Observable<any> {
        this._spinnerService.show();
        return this._http.delete<any>(CONFIG.baseUrls.admin.complaintConfiguration.deleteComplaintByID + id)
            .pipe(
                catchError(this._exceptionService.catchBadResponse),
                finalize(() => this._spinnerService.hide())
            );
    }

}
